/* eslint-disable no-dupe-keys */
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  button: {
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    width: 100,
  },
  form: {
    '& > div': {
      marginBottom: theme.spacing(2),
    },
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    color: theme.palette.secondary.dark,
    textDecoration: 'underline',
  },
  root: {
    margin: '0 auto',
    maxWidth: 1920,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 12),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(2, 28),
    },
    [theme.breakpoints.up('xl')]: {
      padding: theme.spacing(2, 42),
    },
    padding: theme.spacing(1, 2),
  },
}));
